import { QCONTENT_STATUS_TEXT } from '@exam-management/components';
import { QuestionStatus } from '@exam-management/graphql';
import type { Theme } from '@mui/material/styles';
import type { OptionSelectionProps } from '@shared/components';

export const KEYWORD_MIN_LENGTH = 2;
export const KEYWORD_MIN_LENGTH_ERROR = 'กรุณาระบุคำค้นหาอย่างน้อย 2 ตัวอักษร';
export const SELECTION_HEIGHT = 44;

export const QUESTION_STATUS_OPTIONS: OptionSelectionProps[] = [
  { label: QCONTENT_STATUS_TEXT[QuestionStatus.Draft], value: QuestionStatus.Draft },
  { label: QCONTENT_STATUS_TEXT[QuestionStatus.Published], value: QuestionStatus.Published },
  { label: QCONTENT_STATUS_TEXT[QuestionStatus.Unpublished], value: QuestionStatus.Unpublished },
  { label: QCONTENT_STATUS_TEXT[QuestionStatus.Disabled], value: QuestionStatus.Disabled },
];

export const SEARCH_FIELD_OPTIONS: OptionSelectionProps[] = [
  { label: 'เนื้อหาคำถาม', value: 'QUESTION' },
  { label: 'ตัวเลือก', value: 'CHOICES' },
  { label: 'คำอธิบายเฉลย', value: 'SOLUTION' },
  { label: 'หนังสืออ้างอิง', value: 'REFERENCE' },
];

interface StatusChipColor {
  text?: string;
  border?: string;
  background?: string;
}

const STATUS_CHIP_COLOR: Record<string, (theme: Theme) => StatusChipColor> = {
  [QuestionStatus.Draft]: (theme) => ({
    text: theme.palette.info.dark,
    border: theme.palette.info.main,
    background: theme.palette.info.lighter,
  }),
  [QuestionStatus.Published]: (theme) => ({
    text: theme.palette.success.dark,
    border: theme.palette.success.main,
    background: theme.palette.success.lighter,
  }),
  [QuestionStatus.Unpublished]: (theme) => ({
    text: theme.palette.warning.dark,
    border: theme.palette.warning.main,
    background: theme.palette.warning.lighter,
  }),
  [QuestionStatus.Disabled]: (theme) => ({
    text: theme.palette.grey[600],
    border: theme.palette.grey[500],
    background: theme.palette.grey[50],
  }),
};

export const getStatusChipSx = (status: string) => (theme: Theme) => {
  const color = STATUS_CHIP_COLOR[status]?.(theme);

  return {
    height: 'auto',
    fontSize: '12px',
    lineHeight: '18px',
    color: color?.text,
    border: `1px solid ${color?.border}`,
    bgcolor: color?.background,
    pr: 1,
    pl: 2,
    py: '12px',
    '& .MuiChip-label': {
      display: 'flex',
      alignItems: 'center',
      px: 0,
      fontSize: '12px',
      lineHeight: '18px',
    },
    '& .MuiChip-deleteIcon': { color: color?.text, fontSize: 16 },
  };
};
